const styles = theme => ({
  textFontSize: {
    fontSize: 12.5,
  },
  footer: {
    marginLeft: '34%',
    marginTop: '120%',
  },
});

export default styles;



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/components/SideDrawer/components/DrawerMenu/components/Footer/styles.js